var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"ws-page"},[_c('ws-exam-groups-list',{on:{"exam-details":_vm.getExamDetails}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }